import loadable from '@loadable/component';

export const NewbuildingGenplanModalContainerLoadable = loadable(() => import('./NewbuildingGenplanModal'));
